module.exports = __webpack_public_path__ + "img/header.c2a287b7.jpg";